import { render, staticRenderFns } from "./DifferenceInMeans.vue?vue&type=template&id=4f8ac70c&scoped=true&"
import script from "./DifferenceInMeans.vue?vue&type=script&lang=js&"
export * from "./DifferenceInMeans.vue?vue&type=script&lang=js&"
import style0 from "./DifferenceInMeans.vue?vue&type=style&index=0&id=4f8ac70c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8ac70c",
  null
  
)

export default component.exports